/**
 * Field-focus helpers for the HITL review workspace (UX4).
 * Shared by the keyboard traversal (DataValidationStage) and the document→field
 * click path (HighlightOverlay) so both directions land focus the same way.
 */

/** Scroll behavior honoring prefers-reduced-motion (WCAG 2.3.3). */
export function scrollBehavior(): ScrollBehavior {
  return window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
}

/**
 * Focus the input of a HighlightableField by field id (fields render `#field-{id}`
 * anchors) and scroll it into view. Returns false when no matching input exists
 * (e.g. a read-only or unrendered field) so callers can fall back.
 */
export function focusFieldInput(fieldId: string): boolean {
  const anchor = document.getElementById(`field-${fieldId}`);
  const input = anchor?.querySelector<HTMLElement>('input, textarea');
  if (!input) return false;
  input.focus();
  anchor?.scrollIntoView({ behavior: scrollBehavior(), block: 'center' });
  return true;
}
